export default function DownloadIcon1({
  size = 20,
  ...rest
}: {
  size?: number;
  [key: string]: any;
}) {
  return (
    <svg
      width={size}
      height={size}
      {...rest}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.5 2.5H9.5V12.5959L5.84197 9.16648C5.64052 8.97762 5.3241 8.98782 5.13523 9.18928C4.94637 9.39074 4.95657 9.70716 5.15803 9.89602L9.15803 13.646C9.3011 13.7801 9.50215 13.8139 9.67431 13.75H10.3257C10.4979 13.8139 10.6989 13.7801 10.842 13.646L14.842 9.89602C15.0434 9.70716 15.0536 9.39074 14.8648 9.18928C14.6759 8.98782 14.3595 8.97762 14.158 9.16648L10.5 12.5959V2.5Z"
        fill="black"
      />
      <path d="M15.5 17.5V16.5625H4.5V17.5H15.5Z" fill="black" />
    </svg>
  );
}
